<template>
  <form @submit.prevent="onSubmit" v-if="loggedIn">
    <div class=" flex rounded-md shadow-sm relative">
      <picker
        @select="addEmoji"
        title="Pick your emoji"
        emoji="point_up"
        :native="true"
        v-show="showEmojiWindow"
      />
      <textarea
        ref="responseRef"
        v-model="responseInput"
        id="about"
        rows="3"
        @input="$emit('input', $event.target.value)"
        class="form-textarea block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
      ></textarea>
    </div>

    <div class="mt-4">
      <div
        class="p-2 flex flex-row items-center"
        v-for="file in largeFiles"
        :key="file.name"
      >
        <svg
          class="w-6 h-6 text-red-600"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-7.536 5.879a1 1 0 001.415 0 3 3 0 014.242 0 1 1 0 001.415-1.415 5 5 0 00-7.072 0 1 1 0 000 1.415z"
            clip-rule="evenodd"
          />
        </svg>
        <span class="font-semibold px-2 text-red-600"
          >Oh no! <span class="text-darkpurple">{{ file.name }}</span> is too
          large. Please upload a file less than 15 MB</span
        >
      </div>
    </div>

    <div class="mt-4" v-if="completeFiles.length > 0">
      <div
        v-for="file in completeFiles"
        :key="file.key"
        class="flex flex-row items-center p-2"
      >
        <div class="flex items-center">
          <svg
            class="flex-shrink-0 h-5 w-5 text-darkpurple"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fill-rule="evenodd"
              d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z"
              clip-rule="evenodd"
            />
          </svg>
          <span class="ml-2 truncate text-black font-semibold tracking-wide">
            {{ file.fileName }}
          </span>
        </div>
        <button
          class="ml-5 text-xs text-red-600"
          @click="() => removeComplete(file.key)"
        >
          Remove
        </button>
      </div>
    </div>

    <div
      class="flex flex-row items-center mt-4 flex-wrap"
      v-if="completeImages.length > 0"
    >
      <div
        v-for="file in completeImages"
        :key="file.key"
        class="flex flex-col items-center mx-2 mb-4"
      >
        <img
          :src="file.url"
          class="w-24 h-24 object-cover border border-gray-200"
        />
        <button
          class="text-xs text-red-600"
          @click="() => removeComplete(file.key)"
        >
          Remove
        </button>
      </div>
    </div>

    <div class="mt-4" v-if="uploading.length > 0">
      <label class="block text-sm leading-5 font-medium text-gray-700">
        Uploading
      </label>
      <div
        class="p-2  border border-gray-300 rounded-lg my-2 text-blue-600"
        v-for="upload in uploading"
        :key="upload.key"
      >
        <span>{{ upload.name }}</span> -
        <span> {{ Math.round(upload.progress) }}% </span>
      </div>
    </div>
    <div class="mt-2 flex flex-row align-center">
      <span class="inline-flex rounded-md shadow-sm">
        <button
          type="submit"
          class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md
           text-white bg-darkpurple font-bebas tracking-wider text-xl hover:bg-pink-600 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out"
           :disabled="isDisabled"
          >
          Post
        </button>
      </span>
      <span class="inline-flex rounded-md shadow-sm ml-2">
        <button
          type="button"
          class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md
              border border-gray-300
            bg-vlight-paper text-gray-500 hover:border-pink-400
            hover:text-pink-400 focus:outline-none focus:border-indigo-700
            focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out"
          v-click-outside="closeevent"
          @click="
            () => {
              showEmojiWindow = !showEmojiWindow;
            }
          "
        >
          <svg
            class="h-6 w-6 stroke-current"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </button>
      </span>
      <label class="inline-flex rounded-md shadow-sm ml-2" for="fileUpload">
        <input
          type="file"
          multiple
          accept="image/*"
          id="fileUpload"
          style="display: none"
          @change.prevent="fileChanged"
        />
        <span
          class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md
              border border-gray-300
            bg-vlight-paper text-darkpurple hover:border-pink-400 hover:text-pink-400 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out"
        >
          <svg
            class="stoke-current h-6 w-6"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
            ></path>
          </svg>
        </span>
      </label>
    </div>
  </form>
</template>

<script>
import { Picker } from "emoji-mart-vue";
import { auth, firebase, topicsCollection } from "../utils/firebase";
import "firebase/storage";
import { createUniqueFileName } from "../utils/fileUtils";
import { mapGetters } from "vuex";
import { ClickOutside } from "../utils/ClickOutside";

export default {
  name: "TopicResponseBox",
  components: { Picker },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      files: {},
      topic: null,
      responseInput: "",
      messagesRef: null,
      messages: [],
      messagesUnsubscribe: null,
      showEmojiWindow: false,
      largeFiles: []
    };
  },
  directives: {
    'click-outside': ClickOutside()
  },
  computed: {
    ...mapGetters(["loggedIn"]),
    isDisabled() {
      return this.responseInput === undefined || this.responseInput == null || this.responseInput.trim().length == 0;
    },
    uploading() {
      const files = this.files;
      return Object.keys(files)
        .filter(key => files[key].state === "UPLOADING")
        .map(key => files[key]);
    },
    complete() {
      const files = this.files;
      return Object.keys(files)
        .filter(key => files[key].state === "COMPLETE")
        .map(key => files[key]);
    },
    completeImages() {
      const files = this.files;
      return Object.keys(files)
        .filter(key => files[key].state === "COMPLETE" && files[key].isImage)
        .map(key => files[key]);
    },
    completeFiles() {
      const files = this.files;
      return Object.keys(files)
        .filter(
          key => files[key].state === "COMPLETE" && files[key].isImage === false
        )
        .map(key => files[key]);
    }
  },
  created() {
    this.messagesRef = topicsCollection.doc(this.id).collection("messages");
    this.$on('closeevent', this.closeevent);
  },
  methods: {
    //
    // File has changes
    //
    closeevent: function () {
    	this.showEmojiWindow = false
    },
    fileChanged(e) {
      Object.keys(this.largeFiles).map(key =>
        this.$delete(this.largeFiles, key)
      );
      const self = this;
      const files = e.target.files;
      [...files].forEach(function(f) {
        if (f.size < 15000000) {
          self.uploadFile(f);
        } else {
          self.largeFiles.push(f);
        }
      });
    },
    //
    // Upload a file to firebase
    //
    uploadFile(file) {
      const self = this;
      let uniqueName = createUniqueFileName(file);
      let path = `/images/${uniqueName}`;
      if (!file.type.startsWith("image/")) {
        path = `/files/${uniqueName}`;
      }
      const uploadTask = firebase
        .storage()
        .ref(path)
        .put(file);

      uploadTask.on(
        "state_changed",
        function(snapshot) {
          // on Progress
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          self.setProgress(snapshot.ref.fullPath, progress, snapshot.ref.name);
        },
        function(error) {
          self.networkError = error;
        },
        function() {
          // on Complete
          uploadTask.snapshot.ref.getDownloadURL().then(function(url) {
            self.setComplete(uploadTask.snapshot.ref.fullPath, url);
          });
        }
      );
    },
    //
    // Set the progress of a particular keyed filed
    //
    setProgress(key, progress, name) {
      this.$set(this.files, key, {
        key: key,
        state: "UPLOADING",
        progress: progress,
        name: name
      });
    },
    //
    // Set an uploading file to be complete
    //
    setComplete(key, url) {
      let isImage = true;
      if (!url.includes("/images")) {
        isImage = false;
      }
      let fileName = key.substring(key.indexOf("/") + 1);
      this.$set(this.files, key, {
        key: key,
        state: "COMPLETE",
        url: url,
        isImage: isImage,
        fileName: fileName
      });
    },
    //
    // Add an emoji and reset the cursor
    //
    addEmoji(emoji) {
      const textarea = this.$refs.responseRef;
      const cursorPosition = textarea.selectionEnd;
      const start = this.responseInput.substring(0, textarea.selectionStart);
      const end = this.responseInput.substring(textarea.selectionStart);
      const text = start + emoji.native + end;
      // this.$emit('input', text)
      this.responseInput = text;
      textarea.focus();
      this.$nextTick(() => {
        textarea.selectionEnd = cursorPosition + emoji.native.length;
      });
      this.showEmojiWindow = false;
    },
    onSubmit() {
      // TODO : Verification
      // TODO : Get original filename into attachment perhaps?
      const attachments = [];
      Object.keys(this.files).map(key =>
        attachments.push({ key: this.files[key].key, url: this.files[key].url })
      );
      this.messagesRef
        .add({
          body: this.responseInput,
          user: auth.currentUser.uid,
          userDisplay: auth.currentUser.displayName,
          timestamp: firebase.firestore.FieldValue.serverTimestamp(),
          attachments: attachments
        })
        .then(docRef => console.log("Document written with ID: ", docRef.id))
        .catch(error => console.error("Error adding a document", error));
      this.responseInput = "";
      Object.keys(this.files).map(key => this.$delete(this.files, key));
      Object.keys(this.largeFiles).map(key =>
        this.$delete(this.largeFiles, key)
      );
    },
    removeComplete(key) {
      this.$delete(this.files, key);
    }
  }
};
</script>

<style scoped>
.emoji-mart {
  position: absolute;
  top: -400px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}
</style>
